<template>
  <div class="privacy-policy-page">
    <h1>Privacy Policy</h1>

    <p>
      Ode to Hospitality Corp. d/b/a Ode (“Ode”) believes in protecting the
      privacy of personal data and wants you to be familiar with how we collect,
      use, and disclose information collected from individuals who visit our
      website (the “Website”). This privacy policy (“Privacy Policy”) covers
      Ode’s practices and procedures as they relate specifically to information
      we collect about you.
    </p>

    <p>
      We gather information through two means – navigational information
      gathered when you visit this Website and information that you provide to
      us. Generally, the information we collect online helps us respond to your
      requests, deliver requested services, and personalize and continually
      improve your experience at Ode.
    </p>

    <h2>Navigational Information</h2>
    <p>
      Ode gathers navigational information about where visitors go on this
      Website. This information allows us to see which areas of this Website are
      most visited and thus improve the quality of our visitors’ experience by
      recognizing and delivering more of the features, services, and products
      our visitors prefer. Additional non-personally identifiable information
      (for example, domain type, browser version, service provider, IP address)
      may be collected, which provides additional information regarding the use
      of this Website, such as how many times a page on this Website is visited.
      Ode uses this information on an aggregate basis to evaluate the
      effectiveness of this Website, to analyze trends, and to administer this
      Website.
    </p>

    <h2>Information You Provide To Us And How We Use It</h2>
    <p>
      Ode does not sell, rent, or trade the information that you provide to us
      at this Website. We may, however, use third parties to help us provide
      services to you. If personally identifiable information (i.e., name,
      address, e-mail address, telephone number) is provided by us or by you
      directly to any of these third parties, we will require that such
      information be maintained by them in confidence.
    </p>

    <p>
      You should also be aware that we may disclose specific information about
      you if necessary to do so by law or based on our good faith belief that it
      is necessary to conform or comply with the law or is necessary to protect
      this Website, the users of this Website, or the public.
    </p>

    <h2>Use Of Cookies</h2>
    <p>
      Ode occasionally uses a browser feature known as a cookie, which assigns a
      unique identification to your computer. Cookies are typically stored on
      your computer’s hard drive and allow a Website to be more responsive to
      your needs, while delivering a better and more personalized experience to
      you. Please also be aware that some of the third-party service providers
      that we use on this Website to help us provide services to you may use
      cookies.
    </p>

    <h2>Changes In Policy</h2>
    <p>
      As we continue to offer you new and different types of content and
      services, Ode may modify our information collection and use practices.
      Should there be a material change to our information practices, it will be
      applied only to information collected on a going-forward basis, and we
      will update this Privacy Policy statement.
    </p>

    <h2>Acceptance Of Terms</h2>
    <p>
      Through the use of this Website, you are hereby accepting the terms and
      conditions stipulated within this Privacy Policy. If you are not in
      agreement with our terms and conditions, then you should refrain from
      further use of our Website. In addition, your continued use of our Website
      following the posting of any updates or changes to our terms and
      conditions shall mean that you are in agreement and acceptance of such
      changes.
    </p>

    <h2>Security</h2>
    <p>
      Ode shall endeavor and shall take every precaution to maintain adequate
      physical, procedural, and technical security with respect to information
      storage facilities so as to prevent any loss, misuse, unauthorized access,
      disclosure, or modification of the user’s personal information under our
      control.
    </p>

    <h2>Questions - Contact Us</h2>
    <p>
      If you have any questions or concerns regarding our privacy practices,
      please contact us.
    </p>
  </div>
</template>

<script>
export default {
  head() {
    return {
      title: "Privacy Policy",
    };
  },
};
</script>

<style scoped>
.privacy-policy-page {
  padding: 150px 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}

h1 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 2em;
}

h2 {
  margin-top: 20px;
  font-size: 1.5em;
  color: #333;
}

p {
  margin-bottom: 15px;
  line-height: 1.6;
  font-size: 1em;
  color: #555;
}

@media (max-width: 768px) {
  h1 {
    font-size: 1.8em;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 1.3em;
  }

  p {
    font-size: 0.95em;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.5em;
  }

  h2 {
    font-size: 1.2em;
  }

  p {
    font-size: 0.9em;
  }
}
</style>
